module.exports = __webpack_public_path__ + "img/hr-tree-01-a-leaves.e771df5f.png";